import { render, staticRenderFns } from "./optionEmailReciboComponent.vue?vue&type=template&id=f485a67e&scoped=true"
import script from "./optionEmailReciboComponent.vue?vue&type=script&lang=js"
export * from "./optionEmailReciboComponent.vue?vue&type=script&lang=js"
import style0 from "./optionEmailReciboComponent.vue?vue&type=style&index=0&id=f485a67e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f485a67e",
  null
  
)

export default component.exports